export default __webpack_public_path__ + "static/media/Greenline_darkBG-trans-green-text.9a293aab.svg";